import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fontsource/open-sans";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";

import { initBeaconBar } from "@greythr/shared-components";

export { wrapRootElement } from '@greythr/shared-store/wrapper';

config.autoAddCss = false;

export const onClientEntry = () => {
  initBeaconBar();
};
